const config = {
  gatsby: {
    pathPrefix: '/courses/object-oriented-analysis-and-design',
    siteUrl: 'https://coursepress.lnu.se',
    gaTrackingId: null
  },
  header: {
    logoLink: '/',
    title: 'logo-wordmark-sv.png',
    courseName: 'Objektorienterad analys och design med UML (1DV607)',
    links: [{ text: '', link: '' }]
  },
  sidebar: {
    frontline: false,
    ignoreIndex: true,
    startCollapsed: true
  },
  siteMetadata: {
    title: 'Linnéuniversitetet',
    courseCode: '1DV607',
    language: "sv",
    description: 'Documentation built with mdx. Powering learn.hasura.io ',
    ogImage: null
  }
}

module.exports = config
